import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ContactForm } from "@/components/shared/ContactForm";
import { useLanguage } from "@/i18n/LanguageContext";

export const CaseEvaluationDialog = ({ trigger }) => {
  const { t } = useLanguage();
  return (
    <Dialog>
      <DialogTrigger asChild data-testid="hero-case-evaluation-trigger">
        {trigger}
      </DialogTrigger>
      <DialogContent className="bg-white max-w-lg" data-testid="case-evaluation-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-[color:var(--navy-950)]">
            {t("caseEvalDialog.title")}
          </DialogTitle>
          <DialogDescription className="text-slate-600">
            {t("caseEvalDialog.description")}
          </DialogDescription>
        </DialogHeader>
        <ContactForm variant="compact" source="hero_case_evaluation" testIdPrefix="case-evaluation" />
      </DialogContent>
    </Dialog>
  );
};
